import Collection_Base from 'collection/base';
import Model_Connected_App_Oauth from 'model/connected_app/oauth';

export default Collection_Base.extend({
    model: Model_Connected_App_Oauth,

    sort_by: 'create_time',
    sort_order: 'desc',

    comparator: function(a, b) {
        var sort_by = a.has(this.sort_by) ? this.sort_by : 'id';

        if (this.sort_order === 'desc') {
            if (a.get(sort_by) === b.get(sort_by)) {
                return a.id >= b.id ? -1 : 1; // always sort by id desc
            } else {
                return a.get(sort_by) > b.get(sort_by) ? -1 : 1;
            }
        } else {
            if (a.get(sort_by) === b.get(sort_by)) {
                return a.id >= b.id ? -1 : 1; // always sort by id desc
            } else {
                return a.get(sort_by) < b.get(sort_by) ? -1 : 1;
            }
        }
    },
});